import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
//昵称修改
export default class NicknameModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.nickname = Stream(app.session.user.nickname());
    this.updateNicknameTime = Stream(app.session.user.updateNicknameTime());
    this.uniqueID = Stream(app.session.user.uniqueID());
    this.nickNameLength = app.forum.attribute('nickNameLength') ? app.forum.attribute('nickNameLength') : 60;
    this.nickNameUpdateTime = app.forum.attribute('nickNameUpdateTime') ? Number(app.forum.attribute('nickNameUpdateTime')) : 7;
    var currentDate = new Date();
    var threeDaysAfter = new Date(this.updateNicknameTime());
    threeDaysAfter.setDate(threeDaysAfter.getDate() + this.nickNameUpdateTime);
    var currentDateMs = currentDate.getTime();
    var threeDaysAfterMs = threeDaysAfter.getTime();
    var timeDiffMs = threeDaysAfterMs - currentDateMs;
    this.timeDiffDays = Math.floor(timeDiffMs / (1000 * 60 * 60 * 24)) + 1;
  }

  className() {
    return 'NickameModal Modal--small';
  }

  title() {
    return app.translator.trans('flarum-nicknames.forum.change_nickname.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <input type="text" required autocomplete="off" name="nickname" maxlength={this.nickNameLength} className="FormControl" bidi={this.nickname} disabled={this.loading} />
              <div className="counter">{this.nickname()?this.nickname().length:0}/{this.nickNameLength}</div>
              {this.updateNicknameTime() && app.session.user.groups().length == 0 && <div>{this.timeDiffDays > 0 ? app.translator.trans('dl-response.forum.nickname_modal.update_limit_time',{day: this.timeDiffDays}) : app.translator.trans('dl-response.forum.nickname_modal.update_limit',{day: this.nickNameUpdateTime})}</div>}
          </div>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
              {app.translator.trans('flarum-nicknames.forum.change_nickname.submit_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onSuccess(text) {
    app.alerts.show({ type: 'success', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  }

  onWarn(text) {
    app.alerts.show({ type: 'warn', dismissible: false, className:'alertClass' }, text)
    setTimeout(function() {
      app.alerts.clear();
    }, 3000);
  }


  onsubmit(e) {
    e.preventDefault();
    if (this.nickname().length>this.nickNameLength) {
      this.onWarn(app.translator.trans('dl-alert.forum.nickname_rule',{length: this.nickNameLength}))
      return
    }
    if (this.updateNicknameTime() && app.session.user.groups().length == 0) {
      if(this.timeDiffDays > 0){
        this.onWarn(this.timeDiffDays + app.translator.trans('flarum-nicknames.forum.change_nickname.update_out_of_time'))
        return;
      }
    }
    if (this.nickname() === app.session.user.nickname()) {
      this.hide();
      return;
    }

    this.loading = true;

    app.session.user
      .save(
        { nickname: this.nickname() },
        {
          errorHandler: this.onerror.bind(this),
        }
      )
      .then(()=>{
        this.onSuccess(app.translator.trans('flarum-nicknames.forum.change_nickname.update_success'))
        this.hide.bind(this)
        this.hide()
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
